<template>
	<div style="position: relative">
		<div style="display: flex; flex-direction: column; gap: 10px">
			<div style="display: flex; align-items: center; gap: 12px">
				<div>
					<button
						class="panel-close-button"
						@click="$emit('closePanel')"
						:title="$t('features.structurePanel.minimize')"
					>
						<svg-icon type="mdi" :path="mdiChevronRight"></svg-icon>
					</button>
				</div>
				<div>
					<h4>{{ $t("common.panels.structure") }}</h4>
				</div>
			</div>

			<div v-for="body of bodies" >
				<div class="structureElement">
					<img width="40px" :src="getImageUrl(body.subArticleId)"/>
					{{ body.subArticleId }} "{{ body.name }}"
				</div>
				<div v-for="instance of body.instances" style="padding-left: 48px">
					<svg-icon v-if="instance.show" type="mdi" :path="mdiEyeCheckOutline" style="cursor: pointer"
						@mouseover="mouseover(instance)"
						@mouseout="mouseout(instance)"
						@click="toggleMesh(instance)">
					</svg-icon>
					<svg-icon v-else type="mdi" :path="mdiEyeOffOutline" style="cursor: pointer"
						@click="toggleMesh(instance)">
					</svg-icon>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useMainStore } from "@/store/mainStore";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiChevronRight } from "@mdi/js";
import { mdiEyeCheckOutline } from "@mdi/js";
import { mdiEyeOffOutline } from "@mdi/js";
import { IBody } from "@/model/IBody";

const store = useMainStore();

const bodies = computed((): any => {
	if (store.cam) {
		if (store.cam.model && store.article.isAssembly) {

			const groupedByPosition = store.cam.model.bodies.reduce<Record<string, IBody[]>>((acc, body) => {
				(acc[body.position] ??= []).push(body);
				return acc;
			}, {});

			const groupedArray = Object.entries(groupedByPosition).map(
				([position, items]) => ({ position, items })
				).filter(g => g.position != '0');

			return groupedArray.map((b) => ({
				position: b.position,
				name: b.items[0].bodyType == 2 ? 
					store.article.assemblyPositionToArticleIdMap.find(m => m.articleId === b.items[0].position)?.name :
					store.article.assemblyPositionToArticleIdMap.find(m => m.position === b.items[0].position)?.name,
				subArticleId: b.items[0].bodyType == 2 ? 
					b.items[0].position : // Einpressungen haben die Artikel id direkt in der Position
					store.article.assemblyPositionToArticleIdMap.find(m => m.position === b.items[0].position)?.articleId,
				instances: b.items,
			}));
		}
	}
	return [];
});

const mouseover = (body: IBody) => {
	store.cam.setFacesColor(body.faces, store.cam.faceHoverColor)
}
const mouseout = (body: IBody) => {
	store.cam.setFacesColor(body.faces, null)
}

const toggleMesh = (body: IBody) => {
	body.show = !body.show;
	store.cam.setDisplayedBodies()
}

const getImageUrl = (articleId: number) : string => {
	var token = store.article.customerId * articleId * 1234;
	var tokenAsString = token.toString();

	return (
		import.meta.env.VITE_APP_ERP_URL +
		`article/getthumbnail?id=${articleId}&time=${Date.now()}&token=${tokenAsString}`
	);
}

</script>

<style>
.structureElement {
  display: flex;
  align-items: center; /* 👈 vertikal zentriert */
  gap: 8px;            /* Abstand zwischen Bild & Text */
}
</style>
